import React from "react";

export default function RestlessTypeFormatter(cellContent) {
  return <div>{cellContent ? "Poll" : "Text / Media"}</div>;
}
